import { hexDistance } from './hex.js';
/** flugzeit = hex_distanz × min_pro_hex / speed_mult / welt_speed */
export function flightTimeMinutes(i) {
    if (i.seasonSpeedMult <= 0 || i.worldSpeed <= 0)
        throw new RangeError('multipliers must be > 0');
    return (hexDistance(i.from, i.to) * i.slowestMinPerHex) / i.seasonSpeedMult / i.worldSpeed;
}
/** Fortschritt 0..1 eines Fluges zum Zeitpunkt now. */
export function flightProgress(departedAt, arrivesAt, now) {
    const total = arrivesAt.getTime() - departedAt.getTime();
    if (total <= 0)
        return 1;
    return Math.max(0, Math.min(1, (now.getTime() - departedAt.getTime()) / total));
}
/** Position (in Hex-Koordinaten, nicht gerundet) entlang der Luftlinie. */
export function interpolateHex(from, to, t) {
    return { q: from.q + (to.q - from.q) * t, r: from.r + (to.r - from.r) * t };
}
//# sourceMappingURL=movement.js.map